import { theme } from '../constants/defaults';

function renderProductInfo(item) {
  const { url, name, variation, vendor, properties } = item;

  const variationText = variation ? `<span class="ajaxcart__product-meta">${variation}</span>` : '';

  const propertiesList = [];
  if (properties) {
    Object.keys(properties).forEach(key => {
      const value = properties[key];

      if (key.substring(0, 1) !== '_' && key !== '') {
        propertiesList.push(`<span class="ajaxcart__product-meta">${key}: ${value}</span>`);
      }
    });
  }

  return `
    <p class="ajaxcart__product-info">
      <a href="${url}" class="ajaxcart__product-name">
        ${name}
      </a>
      ${variationText}
      ${propertiesList.join('')}

      ${theme.settings.cartVendor ? `<span class="ajaxcart__product-meta">${vendor}</span>` : ''}
    </p>
  `;
}

function renderProductQuantity(item) {
  const { key, quantity } = item;

  return `
    <label for="${key}-quantity" class="vh">${theme.strings.cart_quantity_label}</label>
    <div class="quantity-select js-quantity-select">
      <button type="button" class="quantity-select__button" data-increment="-1">
        <span aria-hidden="true">
          <svg class="icon icon-chevron">
          <use xlink:href="#icon-chevron"/>
        </svg>
        </span>
        <span class="vh">${theme.strings.cart_reduce_quantity}</span>
      </button>
      <input type="number"
        class="quantity-select__input"
        min="0"
        id="${key}-quantity"
        name="updates[]" value="${quantity}"
        data-key="${key}"
      />
      <button type="button" class="quantity-select__button" data-increment="1">
        <span aria-hidden="true">  
        <svg class="icon icon-chevron">
          <use xlink:href="#icon-chevron"/>
        </svg></span>
        <span class="vh">${theme.strings.cart_increase_quantity}</span>
      </button>
    </div>
  `;
}

function renderProductPrice(item) {
  const { discountsApplied, linePrice } = item;

  if (discountsApplied) {
    return `
      <small class="ajaxcart__price-strikethrough">
        <s>${item.originalLinePrice}</s>
      </small>
      <br><span class="ajaxcart__price">${linePrice}</span><br>
      ${item.discounts
        .map(discount => {
          return `<small class="ajaxcart__discount">${discount.title}</small><br>`;
        })
        .join('')}
    `;
  }

  return `
    <span class="ajaxcart__price">${linePrice}</span>
  `;
}

function renderProductImage(item) {
  if (item.image === null) {
    return '';
  }

  const { url, image } = item;
  return `
    <a href="${url}" class="ajaxcart__product-image">
      <img src="${image.url}" alt="${image.alt}">
    </a>
  `;
}

export default function(item) {
  const { key } = item;

  return `
    <div class="ajaxcart__product" data-key="${key}">
      <div class="grid">
        <div class="grid__item one-third">
          ${renderProductImage(item)}
        </div>
        <div class="grid__item two-thirds">
          ${renderProductInfo(item)}

          <div class="ajaxcart__product-line">
            ${renderProductQuantity(item)}
            ${renderProductPrice(item)}
          </div>
        </div>
      </div>
    </div>
  `;
}
